import React, { useState } from 'react';
import { news } from '../mockData';
import { useNavigate } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';

const ITEMS_PER_PAGE = 6;

const NewsPage = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  // Ordenar noticias por fecha (más recientes primero)
  const sortedNews = [...news].sort((a, b) => new Date(b.date) - new Date(a.date));

  const totalPages = Math.ceil(sortedNews.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const currentNews = sortedNews.slice(startIndex, endIndex);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('es-ES', { 
      day: 'numeric',
      month: 'short', 
      year: 'numeric'
    });
  };

  const handleNewsClick = (slug) => {
    navigate(`/noticias/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="news-page" data-testid="news-page">
      <div className="news-hero">
        <div className="container">
          <h1 className="heading-2">NOTICIAS</h1>
          <div className="title-underline"></div>
          <p className="body-large">Todas las novedades de Elite Internacional Sport Agency</p>
        </div>
      </div>

      <div className="news-content">
        <div className="news-grid" data-testid="news-grid">
          {currentNews.map((item) => (
            <article 
              key={item.id} 
              className="news-card"
              onClick={() => handleNewsClick(item.slug)}
              data-testid={`news-card-${item.id}`}
            >
              <div className="news-card-image-container">
                <img
                  src={item.image}
                  alt={item.title}
                  className="news-card-image"
                />
                <div className="news-card-category">
                  <span className="caption">{item.category}</span>
                </div>
              </div>
              <div className="news-card-content">
                <div className="news-card-date">
                  <Calendar size={14} />
                  <span className="caption">{formatDate(item.date)}</span>
                </div>
                <h2 className="heading-5">{item.title}</h2>
                <p className="body-small">{item.summary}</p>
                <button className="news-card-btn">
                  Leer más
                  <ArrowRight size={16} />
                </button>
              </div>
            </article>
          ))}
        </div>

        {/* Paginación */}
        {totalPages > 1 && (
          <div className="news-pagination" data-testid="news-pagination">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={currentPage === 1 ? 'pagination-btn-disabled' : 'pagination-btn'}
              data-testid="pagination-prev"
            >
              Anterior
            </button>

            <div className="pagination-numbers">
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(index + 1)}
                  className={currentPage === index + 1 ? 'pagination-number-active' : 'pagination-number'}
                  data-testid={`pagination-page-${index + 1}`}
                >
                  {index + 1}
                </button>
              ))}
            </div>

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={currentPage === totalPages ? 'pagination-btn-disabled' : 'pagination-btn'}
              data-testid="pagination-next"
            >
              Siguiente
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsPage;
